











































































































import { Component, Vue, Watch } from "vue-property-decorator";
import Grid from "./lib/grid";
import GridConfig from "./lib/gridConfig";
@Component({
  filters: {
    toFixed(value: number, digits = 3) {
      if (!value) {
        return "";
      }
      if (typeof value === "number") {
        return value.toFixed(digits);
      }
      return value;
    }
  }
})
export default class App extends Vue {
  private config: GridConfig[];
  constructor() {
    super();
    this.config = [new GridConfig("小网")];
  }
  public mounted() {
    this.$watch(
      function() {
        return this.config[0].price;
      },
      function() {
        this.config[1].price =
          this.config[0].price * (1 - this.config[1].percentage / 100);
        this.config[2].price =
          this.config[0].price * (1 - this.config[2].percentage / 100);
        this.config[1].price = Number.parseFloat(
          this.config[1].price.toFixed(3)
        );
        this.config[2].price = Number.parseFloat(
          this.config[2].price.toFixed(3)
        );
      }
    );
  }
  /**
   * @returns {Grid[][]}
   */
  get gridList() {
    const list: Grid[][] = [];
    for (const configItem of this.config) {
      const tempPer = configItem.percentage / 100;
      const tempList: Grid[] = [];
      for (let i = 0; i < configItem.gridCount; ++i) {
        if (
          i === 0 &&
          (configItem.name === "中网" || configItem.name === "大网")
        ) {
          continue;
        }
        const gear = 1 - i * tempPer; // 档位
        if (gear < 0) {
          continue;
        }
        const buyPrice = Number.parseFloat(
          (configItem.price * gear).toFixed(3)
        ); // 买入价格
        const sellOutPrice = Number.parseFloat(
          (configItem.price * (gear + tempPer)).toFixed(3)
        ); // 卖出价格
        let buyAmount = configItem.buyAmount; // 买入数量
        let cost = 0;
        // 加码
        if (configItem.isMore) {
          buyAmount =
            configItem.buyAmount * (1 + (configItem.morePercentage / 100) * i);
        }
        if (i === 0) {
          cost = buyPrice;
        } else {
          const tempBuyCost =
            tempList.reduce(
              (accumulator, gridItem) =>
                accumulator + gridItem.getBuyAmount() * gridItem.getBuyPrice(),
              0
            ) +
            buyPrice * buyAmount;
          const tempBuyAmount =
            tempList.reduce(
              (accumulator, gridItem) => accumulator + gridItem.getBuyAmount(),
              0
            ) + buyAmount;
          cost = tempBuyCost / tempBuyAmount;
        }
        const item = new Grid(
          configItem.name,
          i + 1,
          gear,
          buyPrice,
          sellOutPrice,
          buyAmount,
          cost
        );
        if (configItem.isRetainProfit) {
          item.retainProfit(configItem.retainProfitMultiple);
        }
        tempList.push(item);
      }
      list.push(tempList);
    }
    return list;
  }
  get sortGrid() {
    return this.gridList.flat().sort((a, b) => {
      return b.getBuyPrice() - a.getBuyPrice();
    });
  }
  public totalValue(index: number) {
    return this.gridList[index].reduce(
      (acc, item) => acc + item.getBuyValue(),
      0
    );
  }
  public totalProfitValue(index: number) {
    return this.gridList[index].reduce(
      (acc, item) => acc + item.getProfitValue(),
      0
    );
  }
  public gridClass(grid: Grid) {
    return {
      "small-grid": grid.getName() === "小网",
      "middle-grid": grid.getName() === "中网",
      "big-grid": grid.getName() === "大网"
    };
  }
  public addGrid() {
    const config = this.config[0];
    if (this.config.length === 1) {
      const newConfig = new GridConfig("中网");
      newConfig.price = config.price;
      newConfig.buyAmount = config.buyAmount;
      newConfig.isRetainProfit = config.isRetainProfit;
      newConfig.isMore = config.isMore;
      newConfig.percentage = 15;
      newConfig.gridCount = 10;
      this.config.push(newConfig);
    } else if (this.config.length === 2) {
      const newConfig = new GridConfig("大网");
      newConfig.price = config.price;
      newConfig.buyAmount = config.buyAmount;
      newConfig.isRetainProfit = config.isRetainProfit;
      newConfig.isMore = config.isMore;
      newConfig.percentage = 30;
      newConfig.gridCount = 5;
      this.config.push(newConfig);
    }
  }
}
